import { createAction, props } from '@ngrx/store';
import { User } from './auth.models';

// login action
export const logins = createAction('[Authentication] Login', props<{ email: string, password: string }>());
export const loginSuccess = createAction('[Authentication] Login Success', props<{ user: any }>());
export const loginFailure = createAction('[Authentication] Login Failure', props<{ error: any }>());

// logout action
export const logout = createAction('[Authentication] Logout');
export const logoutSuccess = createAction('[Auth] Logout Success');

// Enable Two Factor
export const enable2Fa = createAction('[Authentication] Enable Two Factor', props<{ otp: string }>());
export const enable2FaSuccess = createAction('[Authentication] Enable Two Factor Success');
export const enable2FaFailure = createAction('[Authentication] Enable Two Factor Failure', props<{ error: any }>());

// Password Setup
export const passwordSetup = createAction('[Authentication] Password Setup', props<{ password: string }>());
export const passwordSetupSuccess = createAction('[Authentication] EnabPassword Setup Success');
export const passwordSetupFailure = createAction('[Authentication] Password Setup Failure', props<{ error: any }>());

//Forgot Password
export const forgotPassword = createAction('[Authentication] Forgot Password', props<{ email: string }>());
export const forgotPasswordSuccess = createAction('[Authentication] Forgot Password Success');
export const forgotPasswordFailure = createAction('[Authentication] Forgot Password Failure', props<{ error: any }>());

//Reset Password
export const resetPassword = createAction('[Authentication] Reset Password', props<{ token: string, email: string, password: string }>());
export const resetPasswordSuccess = createAction('[Authentication] Reset Password Success');
export const resetPasswordFailure = createAction('[Authentication] Reset Password Failure', props<{ error: any }>());


// login action
export const applyLogins = createAction('[Authentication] Login Apply', props<{ urlData: string }>());
export const applyLoginSuccess = createAction('[Authentication] Login Apply Success', props<{ user: any }>());
export const applyLoginFailure = createAction('[Authentication] Login Apply Failure', props<{ error: any }>());

// back to portal action
export const backToPortal = createAction('[Authentication] Back To Portal');
export const backToPortalSuccess = createAction('[Auth] Back To Portal Success');


//Fetched Logged In
export const currentUser = createAction('[Authentication] Current User');
export const currentUserSuccess = createAction('[Authentication] Current User Success', props<{ user: any }>());
export const currentUserFailure = createAction('[Authentication] Current User Failure', props<{ error: any }>());